import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  Grid,
  Chip,
  Pagination,
  InputAdornment,
  Autocomplete,
  Skeleton,
  Slide,
  Paper,
  Tooltip,
  DialogActions,
  DialogContentText,
  DialogContent,
  DialogTitle,
  Dialog,
  IconButton,
} from "@mui/material";
import searchPageImg from "../../../img/imageSearch.png";
import { styled } from "@mui/material/styles";
import {
  BusinessCenterOutlined,
  Close,
  CurrencyRupeeOutlined,
  LocationOnOutlined,
  MoneyOutlined,
  SettingsOutlined,
  TaskOutlined,
  Work,
  WorkOutline,
} from "@mui/icons-material";
import { CurrentStateContext } from "../../../App";
import { ROUTINGDATA } from "../../ROUTINGDATA";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import employerdefaultimg from "../../../img/employer/empUpdateProfileLogo.png";
import JobFilterMUI from "./JobFilterMUI";
import JobFilterResponsive from "./JobFilterResponsive";
import { formatJobDescription } from "../../../utility/data_storage";
import DOMPurify from "dompurify";
const StyledSearchTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderColor: "#f5f5f5",
    backgroundColor: "#f5f5f5",
    width: "100%",
    height: "60px",

    "&:hover fieldset": {
      borderColor: "#f5f5f5",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#f5f5f5",
    },
  },
  "& .MuiInputBase-root": {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#f5f5f5",
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#404040", // Light gray placeholder text
      opacity: 1, // Ensures the placeholder is fully visible
    },
  },
}));
const ellipsisStyle = {
  maxWidth: 230,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function SearchPage2() {
  const [page, setPage] = useState(1);
  let location = useLocation();
  let params = useParams();
  const { axiosData, customBreakpoints } = useContext(CurrentStateContext);
  const navigate = useNavigate();
  const [jobDetails1, setJobDetails1] = useState();
  const [jobList, setJobList] = useState([]);

  const [isLoaded, setIsLoaded] = useState(false);

  const [seekerProfileDetails, setSeekerProfileDetails] = useState();
  const [Applyed, setApplyed] = useState([]);
  const [jobApplied, setJobApplied] = useState(false);
  const [description, setDescription] = useState([]);
  const [description2, setDescription2] = useState([]);
  const [openMoreDetails, setOpenMoreDetails] = useState(false);
  const [openMoreDetails2, setOpenMoreDetails2] = useState(false);
  const [jobDescription, setJobDescription] = useState(null);
  const [jobDescription2, setJobDescription2] = useState();
  let seekerDetails = JSON.parse(localStorage.getItem("seeker"));
  const [searchPopUp, setSearchPopUp] = useState(false);
  const [mobilesearch, setmobilesearch] = useState(false);
  const [searchQuerySkills, setSearchQuerySkills] = useState("");
  const [searchQueryLocation, setSearchQueryLocation] = useState("");
  const [suggestionArray, setSuggestionArray] = useState([]);
  const [suggestionArrayl, setSuggestionArrayl] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({
    key_skills: null,
    job_location: null,
    industry: null,

    job_mode: [], // new
    job_type: [], // new
    experience: [], // new
    salary: [0, 50],

    page_number: 1,
  });
  const [loadMore, setLoadMore] = useState(false);
  const [loadDisabled, setLoadDisabled] = useState([]);
  const [loading, setLoading] = useState(true);
  const [login, setLogin] = useState(false);
  const [noResultPopUp, setNoResultPopUp] = useState(false);
  const [totalData, setTotalData] = useState();
  const [searchTotalData, setSearchTotalData] = useState();
  const [searchjobid, setsearchjobid] = useState();
  const [higlightjob, sethiglightjob] = useState("");
  const [higlightjobs_1, sethiglightjobs_1] = useState(true);
  const [totalPage, setTotalPage] = useState(0);
  const itemsPerPage = 6;

  const totalPages = (totalCount = jobList.length) => {
    return Math.ceil(totalCount / itemsPerPage);
  };
  let emailName2;
  if (seekerDetails) {
    emailName2 = seekerDetails.emailId;
  }

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const match = (Id) => {
    let value = true;
    Applyed.map((values, index) => {
      if (Id === values.job_id) {
        value = false;
      }
    });

    return value;
  };

  const searchResult1 = async (result) => {
    selectedOptions.industry = result.industry;
    selectedOptions.key_skills = result.key_skills;
    selectedOptions.job_location = result.job_location;
    setSelectedOptions(selectedOptions);
    if (params.id !== "result" && params.id !== undefined) {
      try {
        const response1 = await axiosData.get(`jobs/getOne/${params.id}`, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response1.status === 200) {
          selectedOptions.key_skills = response1.data.job_title;
          result.key_skills = response1.data.job_title;
          setJobDetails1(response1.data);
          setsearchjobid(response1.data.job_id);
          setDescription2(response1.data.job_description);

          try {
            const response = await axiosData.post(`jobs/search`, result, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
            if (response.data) {
              if (response.data.data) {
                const activeJobs = response.data.data.filter(
                  (datas) => datas.job_status === "Active",
                );
                const filterjobs = activeJobs.filter(
                  (items) => items._id !== response1.data._id,
                );
                setTotalData(response.data.total_record);
                setLoadDisabled(response.data.is_last_record_set);
                setJobList([...filterjobs]);
                setTotalPage(totalPages(response.data.total_record));

                setDescription([...filterjobs.map((job) => job.description)]);
              } else {
                const activeJobs = response.data.filter(
                  (datas) => datas.job_status === "Active",
                );
                const filterjobs = activeJobs.filter(
                  (items) => items._id !== response1.data._id,
                );
                setJobList([...filterjobs]);
                setTotalPage(totalPages(response.data.total_record));

                setDescription([...filterjobs.map((job) => job.description)]);
                setTotalData(response.data.total_record);
                setLoadDisabled(response.data.is_last_record_set);
              }
              const temp = response.data.is_last_record_set;
              setLoading(false);
            }
            if (response.status === 204) {
              setSelectedOptions({
                key_skills: null,
                job_location: null,
                industry: null,
              });
              setSearchTotalData("");
              setTotalData(0);
              setLoading(false);
              setNoResultPopUp(true);
            }
          } catch (err) {
            // alert("No jobs for your search");

            console.log(err);
          }
        } else {
          sethiglightjobs_1(false);
          setSelectedOptions("");
          setSearchTotalData("");
          setTotalData(0);
          setSelectedOptions({
            key_skills: null,
            job_location: null,
            industry: null,
          });
          setSelectedOptions(selectedOptions);
          setLoading(false);
          setNoResultPopUp(true);
        }
      } catch (err) {}
    } else if (location.state.search._id) {
      try {
        const response1 = await axiosData.get(
          `urgentjobs/getOne/${location.state.search._id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        setJobDetails1(response1.data);
        setsearchjobid(response1.data.job_id);
        setDescription2(response1.data.job_description);
        try {
          const response = await axiosData.post(`jobs/search`, result, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (response.data) {
            if (response.data.data) {
              const activeJobs = response.data.data.filter(
                (datas) => datas.job_status === "Active",
              );
              const filterjobs = activeJobs.filter(
                (items) => items._id !== response1.data.job_id,
              );
              setTotalData(response.data.total_record);
              setLoadDisabled(response.data.is_last_record_set);
              setJobList([...filterjobs]);
              setTotalPage(totalPages(response.data.total_record));

              setDescription([...filterjobs.map((job) => job.description)]);
            } else {
              const activeJobs = response.data.filter(
                (datas) => datas.job_status === "Active",
              );
              const filterjobs = activeJobs.filter(
                (items) => items._id !== response1.data.job_id,
              );
              setJobList([...filterjobs]);
              setTotalPage(totalPages(response.data.total_record));

              setDescription([...filterjobs.map((job) => job.description)]);
              setTotalData(response.data.total_record);
              setLoadDisabled(response.data.is_last_record_set);
            }
            const temp = response.data.is_last_record_set;
            setLoading(false);
          }
          if (response.status === 204) {
            setSelectedOptions({
              key_skills: null,
              job_location: null,
              industry: null,
            });
            setSearchTotalData("");
            setTotalData(0);
            setLoading(false);
            setNoResultPopUp(true);
          }
        } catch (err) {
          // alert("No jobs for your search");

          console.log(err);
        }
      } catch (err) {}
    } else {
      sethiglightjobs_1(false);
      sethiglightjob("");
      try {
        const response = await axiosData.post(`jobs/search`, result, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.data) {
          if (response.data.data) {
            setTotalData(response.data.total_record);
            setLoadDisabled(response.data.is_last_record_set);
            setJobList([...response.data.data]);
            setTotalPage(totalPages(response.data.total_record));

            setDescription([
              ...response.data.data.map((job) => job.description),
            ]);
          } else {
            setJobList([...response.data]);
            setTotalPage(totalPages(response.data.total_record));

            setDescription([...response.data.map((job) => job.description)]);
            setTotalData(response.data.total_record);
            setLoadDisabled(response.data.is_last_record_set);
          }
          const temp = response.data.is_last_record_set;
          setLoading(false);
        }
        if (response.status === 204) {
          setSelectedOptions("");
          setSearchTotalData("");
          setTotalData(0);
          setSelectedOptions({
            key_skills: null,
            job_location: null,
            industry: null,
          });
          setSelectedOptions(selectedOptions);
          setLoading(false);
          setNoResultPopUp(true);
        }
      } catch (err) {
        // alert("No jobs for your search");

        console.log(err);
      }
    }
  };

  useEffect(() => {
    if ((params.id !== "result") && (params.id !== undefined)) {
      if (emailName2) {
        navigate(
          `${ROUTINGDATA.LAND}${ROUTINGDATA.MAIN}${ROUTINGDATA.seekerProfile}`,
          { state: emailName2 },
        );
        navigate("/main/RecommendedJob", {
          state: {
            industry: {
              industry: "",
              key_skills: "",
              job_location: "",
              page_number: 1,
              job_id: params.id,
            },
            _id: seekerDetails._id,
            email_id: emailName2,
            from: "LandingPage",
          },
        });
      } else {
        if (location.state?.search?._id) {
          sethiglightjob(location.state?.search?._id);
          searchResult1(location.state?.search);
        } else {
          searchResult({
            industry: "",
            key_skills: "",
            job_location: "",
            page_number: 1,
          });
        }
      }
    } else {
      // sethiglightjob(location.state.search._id);
      searchResult(location?.state?.search);
    }
  }, []);
  const moreDetails2 = (description) => {
    setOpenMoreDetails2(true);
    setJobDescription2(jobDetails1.job_description);
  };
  const moreDetails = (description) => {
    setOpenMoreDetails(true);
    const job_description = jobList.find(
      (item) => item.job_description === description,
    );
    console.log("job_description", job_description);
    setJobDescription(job_description);
  };
  const baseUrl = axiosData.defaults.baseURL;
  const Apply = async (job) => {
    setLogin(true);
  };

  // const searchobj = (values, string) => {
  //   selectedOptions[string] = values;
  //   setSelectedOptions(selectedOptions);
  //   setSuggestionArray([]);
  //   setSuggestionArrayl([]);
  // };

  const searchobj = (values, string) => {
    // Create new object instead of mutating
    setSelectedOptions((prev) => ({
      ...prev,
      [string]: values,
    }));
    setSuggestionArray([]);
    setSuggestionArrayl([]);
  };

  const handleSuggestionsSkills = async (event) => {
    let query = event.target.value;

    if (query.startsWith("#")) {
      query = query.slice(1);
    }

    setSearchQuerySkills(query); // Use separate state

    if (query.length >= 3) {
      try {
        const response = await axiosData.get(`/jobs/suggestion/${query}`);
        const filteredData = response.data
          ? response.data.filter((item) => !!item)
          : [];
        setSuggestionArray(filteredData);
      } catch (err) {
        console.log(err);
        setSuggestionArray([]);
      }
    } else {
      setSuggestionArray([]);
    }
  };

  const handleSuggestionslocation = async (event) => {
    let query = event.target.value.replace(/[^a-z., ]/gi, "");

    setSearchQueryLocation(query); // Use separate state

    if (query.length >= 3) {
      try {
        const response = await axiosData.get(
          `/jobs/suggestionlocation/${query}`,
        );
        console.log(response);

        const filteredData = response.data
          ? response.data.filter((item) => !!item)
          : [];
        setSuggestionArrayl(filteredData);
      } catch (err) {
        console.log(err);
        setSuggestionArrayl([]);
      }
    } else {
      setSuggestionArrayl([]);
    }
  };

  const searchResult = async (result, filter) => {
    console.log("searchResult called with:", { result, filter });
    if (
      ((result?.industry === null || result?.industry === "") &&
        (result?.key_skills === null || result?.key_skills === "") &&
        (result?.job_location === null || result?.job_location === "") &&
        (result?.recent_job === null || result?.recent_job === "")) ||
      filter
    ) {
      // alert("atlest one field is requried");
      setSearchPopUp(true);
    } else {
      setLoading(true);
      try {
        const response = await axiosData.post(`jobs/search`, result, {
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.data) {
          setSearchTotalData(response.data.total_record);
          setLoadDisabled(response.data.is_last_record_set);
          setJobList([...response.data.data]);
          setTotalPage(totalPages(response.data.total_record));

          setDescription([...response.data.data.map((job) => job.description)]);

          setmobilesearch(false);
          setLoading(false);
        }
        if (response.status === 204) {
          setSelectedOptions({
            key_skills: null,
            job_location: null,
            industry: null,
          });

          setSearchTotalData("");
          setTotalData(0);
          setJobList([]);
          setDescription([]);
          setLoading(false);
          setNoResultPopUp(true);
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const handleSearch = () => {
    selectedOptions.page_number = 1;
    setSelectedOptions(selectedOptions);
    searchResult(selectedOptions);
    sethiglightjobs_1(false);
    sethiglightjob("");
  };

  const loadMoreData = async () => {
    setLoadMore(true);
    if (
      selectedOptions.industry === null &&
      selectedOptions.key_skills === null &&
      selectedOptions.job_location === null
    ) {
      // alert("atlest one field is requried");
      setSearchPopUp(true);
    } else {
      try {
        const response = await axiosData.post(`jobs/search`, selectedOptions, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data) {
          if (higlightjob) {
            const filterjobs = response.data.data.filter(
              (items) => items._id !== searchjobid,
            );
            setLoadDisabled(response.data.is_last_record_set);
            setJobList([...jobList, ...filterjobs]);
            setTotalPage(totalPages(response.data.total_record));

            setDescription([
              ...description,
              ...filterjobs.map((job) => job.description),
            ]);
            setmobilesearch(false);
            setLoading(false);
          } else {
            sethiglightjobs_1(false);
            sethiglightjob("");
            setLoadDisabled(response.data.is_last_record_set);
            setJobList([...jobList, ...response.data.data]);
            setTotalPage(totalPages(response.data.total_record));

            setDescription([
              ...description,
              ...response.data.data.map((job) => job.description),
            ]);
            setmobilesearch(false);
            setLoading(false);
          }
        }
        if (response.status === 204) {
          setSelectedOptions({
            key_skills: null,
            job_location: null,
            industry: null,
          });
          setSelectedOptions(selectedOptions);
          setSearchTotalData("");
          setTotalData(0);
          setLoading(false);
          setNoResultPopUp(true);
        }
      } catch (err) {
        // alert("No jobs for your search");

        console.log(err);
      }
    }
    setLoadMore(false);
  };

  const filterOptions = (options, { inputValue }) => {
    // Handle cases where inputValue is not a string
    if (!inputValue || typeof inputValue !== "string") {
      return options;
    }

    const inputValueLower = inputValue.toLowerCase();
    const startsWithInput = [];
    const containsInput = [];

    options.forEach((option) => {
      // Also check if option is a valid string
      if (option && typeof option === "string") {
        const optionLower = option.toLowerCase();
        if (optionLower.startsWith(inputValueLower)) {
          startsWithInput.push(option);
        } else if (optionLower.includes(inputValueLower)) {
          containsInput.push(option);
        }
      }
    });

    return [...startsWithInput, ...containsInput];
  };

  const [industryArray, setIndustryArray] = useState();

  const IndustryData = async () => {
    try {
      const getOneAxios = await axiosData.get(`/General/seekerSettings`);
      const data = getOneAxios?.data?.industryData;
      if (data) {
        setIndustryArray(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  useEffect(() => {
    IndustryData();
  }, []);
  const handleFilterChange = (filters) => {
    setSelectedOptions((prev) => ({
      ...prev,
      ...filters,
      page_number: 1, // reset page when filter changes
    }));
    // 🔥 Immediately trigger search after filter change
    setTimeout(() => {
      searchResult(
        {
          ...selectedOptions,
          ...filters,
          page_number: 1,
        },
        false,
      );
    }, 0);
  };

  return (
    <Box sx={{ minHeight: "100vh", width: "100%" }}>
      {/* Hero Section */}
      <Box
        sx={{
          background: `
    linear-gradient(
      90deg, 
      rgba(236, 33, 114,0.5) 6%, 
      rgba(0, 94, 178,0.5) 53%, 
      rgba(236, 33, 114,0.5) 100%
    ),
    url(${searchPageImg})
  `,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          color: "white",
          py: 12,
          px: 2,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            align="center"
            sx={{
              fontWeight: 600,
              mb: 1,
              fontFamily: "Poppins-SemiBold",
              fontSize: "40px",
            }}
          >
            Your Next Career Move Starts Here
          </Typography>
          <Typography
            align="center"
            sx={{
              mb: 1,
              fontFamily: "Poppins-SemiBold",
              fontSize: "40px",
            }}
          >
            with Velaivendum
          </Typography>
          <Typography
            align="center"
            sx={{ mb: 4, fontFamily: "Poppins-Medium", fontSize: "14px" }}
          >
            Search thousands of verified jobs that match your skills and career
            goals.
          </Typography>

          {/* Search Bar */}
          <Box
            sx={{
              bgcolor: "white",
              p: "6px",
              display: "flex",
              gap: 2,
              flexWrap: "wrap",
              borderRadius: "20px",
            }}
          >
            {/* KeySkills Autocomplete */}
            <Autocomplete
              disablePortal
              freeSolo
              options={suggestionArray}
              value={selectedOptions.key_skills || ""}
              inputValue={searchQuerySkills} // Use separate state
              onInputChange={(event, newValue) => {
                if (event) {
                  handleSuggestionsSkills({ target: { value: newValue } });
                }
              }}
              onChange={(event, value) => {
                searchobj(value, "key_skills");
              }}
              isOptionEqualToValue={(option, value) => option === value}
              disableUnderline={false}
              sx={{ flex: "1 1 200px" }}
              renderInput={(params) => (
                <StyledSearchTextField
                  disableUnderline={false}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "16px 0 0 16px",
                    },
                  }}
                  {...params}
                  placeholder={"Enter KeySkills / Designations / Companies"}
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <BusinessCenterOutlined sx={{ color: "#6E6C6C" }} />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />

            {/* Industry Autocomplete */}
            {/* {industryArray && (
              <Autocomplete
                disablePortal
                id="Select_experience"
                name="Select_experience"
                filterOptions={filterOptions}
                options={industryArray}
                value={selectedOptions.industry || null}
                onChange={(event, value) => {
                  searchobj(value, "industry");
                }}
                isOptionEqualToValue={(option, value) => option === value}
                sx={{ width: { xs: 350, md: 180, lg: 300 }, flex: "1 1 200px" }}
                renderInput={(params) => (
                  <StyledSearchTextField
                    {...params}
                    placeholder={"Enter Industry"}
                    size="small"
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: (
                        <>
                          <SettingsOutlined sx={{ color: "#6E6C6C" }} />
                          {params.InputProps.startAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            )} */}
            <Autocomplete
              disablePortal
              freeSolo
              id="Enter_location"
              name="Enter_location"
              options={suggestionArrayl}
              onChange={(event, value) => searchobj(value, "job_location")}
              value={selectedOptions.job_location}
              inputValue={searchQueryLocation} // Use separate state
              onInputChange={(event, newValue) => {
                console.log(event, newValue);
                if (event) {
                  handleSuggestionslocation({ target: { value: newValue } });
                }
              }}
              isOptionEqualToValue={(option, value) => option === value}
              sx={{ width: { xs: 350, md: 180, lg: 300 }, flex: "1 1 200px" }}
              renderInput={(params) => (
                <StyledSearchTextField
                  {...params}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0 16px 16px 0",
                    },
                  }}
                  placeholder={"Enter Location"}
                  size="small"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <LocationOnOutlined sx={{ color: "#6E6C6C" }} />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <Button
              sx={{
                borderRadius: "16px",
                padding: "10px 33px",
                margin: { xs: "0 auto", md: "0 auto" },
                width: "184px",
                height: "60px",
                fontSize: "16px",
                fontFamily: "Poppins-Medium",
                backgroundColor: "#005E82",
                textTransform: "capitalize",
                "&.MuiButtonBase-root-MuiButton-root:hover": {
                  backgroundColor: "red !important",
                },
              }}
              disableElevation
              onClick={handleSearch}
              variant="contained"
            >
              {"search"}
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Recent Jobs Section */}
      <Container  sx={{ py: 6 }}>
        <Box
          sx={{
            
            borderRadius: 2,
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
          }}
        >
          <JobFilterResponsive
            onChange={handleFilterChange}
            categories={industryArray}
          />
          <Box width={"90%"} p={1}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 3,
              }}
            >
              <Typography
                sx={{ fontFamily: "Poppins-SemiBold", fontSize: "30px" }}
              >
                {
                  // !isLoaded ? (
                  //   <Skeleton
                  //     animation="wave"
                  //     variant="text"
                  //     width={230}
                  //     height={40}
                  //     sx={{ borderRadius: "15px" }}
                  //   />
                  // ) :
                  "Recent Jobs"
                }
              </Typography>
              {/* <IconButton size="small">
                  <FilterList />
                </IconButton> */}
            </Box>

            {/* Job Cards Grid */}
            <Grid container spacing={3}>
              {
               !loading ? (
                jobList.length > 0 ? (
                  jobList.map((job) => (
                    <Grid
                      item
                      xs={12} // 📱 Mobile → 1 card
                      sm={12} // 📲 Tablet → 2 cards
                      md={12} // 💻 Small laptop → 2 cards
                      lg={12} // 🖥 Desktop → 3 cards
                      key={job.id}
                      sx={{ display: "flex" }}
                    >
                      <Card
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          "&:hover": { boxShadow: 4 },
                          boxShadow: "0px 0px 10px rgba(0,0,0,0.2)",
                          borderRadius: "8px",
                          width: "100%",
                        }}
                      >
                        <CardContent
                          sx={{
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {/* Job Header */}
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: customBreakpoints.isMobileDown
                                ? "column-reverse"
                                : "row",
                              justifyContent: "space-between",
                              alignItems: "flex-start",
                              mb: 2,
                            }}
                          >
                            <Box>
                              {/* Job Title */}
                              <Typography
                                variant="h6"
                                fontWeight="600"
                                gutterBottom
                                sx={{
                                  fontFamily: "Poppins-SemiBold",
                                  ...ellipsisStyle,
                                }}
                              >
                                {
                                  // isLoaded ? (
                                  <Tooltip title={job.job_title} arrow>
                                    <span>{job.job_title}</span>
                                  </Tooltip>
                                  // ) :
                                  // (
                                  //   <Skeleton
                                  //     animation="wave"
                                  //     variant="text"
                                  //     width={230}
                                  //     height={40}
                                  //   />
                                  // )
                                }
                              </Typography>

                              {/* Company Name */}
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                  fontFamily: "Poppins-Medium",
                                  ...ellipsisStyle,
                                }}
                              >
                                {/* {isLoaded ? ( */}
                                <Tooltip title={job.company_name} arrow>
                                  <span>{job.company_name}</span>
                                </Tooltip>
                                {/* // ) : (
                                  //   <Skeleton
                                  //     animation="wave"
                                  //     variant="text"
                                  //     width={230}
                                  //     height={40}
                                  //   />
                                  // )} */}
                              </Typography>
                            </Box>

                            {/* Company Logo */}
                            <img
                              src={
                                job.logoUpload
                                  ? `${baseUrl}employers/logo/email/${job.employer_email_id}/Admin`
                                  : employerdefaultimg
                              }
                              alt="logo"
                              width="50"
                              height="50"
                              style={{
                                objectFit: "contain",
                                borderRadius: "6px",
                              }}
                            />
                          </Box>

                          {/* Job Details */}
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              flexWrap: "wrap",
                              gap: 2,
                              mb: 2,
                              flexGrow: 1,
                            }}
                          >
                            {/* Job Type */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <BusinessCenterOutlined
                                fontSize="small"
                                color="action"
                              />
                              <Typography
                                variant="body2"
                                color="#107334"
                                sx={{ fontFamily: "Poppins-Medium" }}
                              >
                                Full Time
                              </Typography>
                            </Box>

                            {/* Experience */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <TaskOutlined fontSize="small" color="action" />
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                  fontFamily: "Poppins-Medium",
                                  ...ellipsisStyle,
                                }}
                              >
                                {/* {isLoaded ? ( */}
                                {`${job.experience_min || 0} - ${
                                  job.experience_max || 1
                                } year experience`}
                                {/* // ) : (
                                  //   <Skeleton
                                  //     animation="wave"
                                  //     variant="text"
                                  //     width={230}
                                  //     height={40}
                                  //   />
                                  // )} */}
                              </Typography>
                            </Box>

                            {/* Location */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <LocationOnOutlined
                                fontSize="small"
                                color="action"
                              />
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                  fontFamily: "Poppins-Medium",
                                  ...ellipsisStyle,
                                }}
                              >
                                {/* {isLoaded ? ( */}
                                <Tooltip title={job.job_location} arrow>
                                  <span>{job.job_location}</span>
                                </Tooltip>
                                {/* // ) : (
                                  //   <Skeleton
                                  //     animation="wave"
                                  //     variant="text"
                                  //     width={230}
                                  //     height={40}
                                  //   />
                                  // )} */}
                              </Typography>
                            </Box>
                            {/* Salary */}
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <CurrencyRupeeOutlined
                                fontSize="small"
                                color="action"
                              />
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                  fontFamily: "Poppins-Medium",
                                  ...ellipsisStyle,
                                }}
                              >
                                {/* {isLoaded ? ( */}
                                <Tooltip
                                  title={`${job.salary_range_min}-${job.salary_range_max}`}
                                  arrow
                                >
                                  <span>{`${job.salary_range_min}-${job.salary_range_max}`}</span>
                                </Tooltip>
                                {/* // ) : (
                                  //   <Skeleton
                                  //     animation="wave"
                                  //     variant="text"
                                  //     width={230}
                                  //     height={40}
                                  //   />
                                  // )} */}
                              </Typography>
                            </Box>
                          </Box>
                          {/* View More */}
                          
                          <Box display="flex" gap={1} mb={2}>
                             <Typography
                              variant="body2"
                              sx={{
                                fontFamily: "Poppins-Medium"
                              }}  >
                                No of Openings: {job.number_of_positions}
                              </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                fontFamily: "Poppins-Medium",
                                color: "#005E82",
                                cursor: "pointer",
                              }}
                              onClick={() => moreDetails(job.job_description)}
                            >
                              View more
                            </Typography>
                          </Box>
                          {/* Footer */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mt: "auto",
                            }}
                          >
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ fontFamily: "Poppins-Medium" }}
                            >
                              {`Posted ${job.createdDate}`}
                            </Typography>

                            <Button
                              variant="contained"
                              disableElevation
                              disabled={
                                job.job_status === "InActive" ||
                                !match(job.job_id)
                              }
                              sx={{
                                bgcolor: "#005E82",
                                "&:hover": { bgcolor: "#005070" },
                                textTransform: "none",
                                fontFamily: "Poppins-Medium",
                                padding: "10px",
                                width: "102px",
                                height: "44px",
                                borderRadius: "8px",
                              }}
                              onClick={Apply}
                            >
                              {match(job?.job_id) ? "Apply" : "Applyed"}
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))
                ) : (
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight="600"
                      sx={{ fontFamily: "Poppins-SemiBold" }}
                    >
                      No jobs Available
                    </Typography>
                  </Box>
                )
                )
                : Array.from({ length: 6 }, (_, i) => i).map((i) => (
                                <Grid item
                      xs={12} // 📱 Mobile → 1 card
                      sm={12} // 📲 Tablet → 2 cards
                      md={12} // 💻 Small laptop → 2 cards
                      lg={12} // 🖥 Desktop → 3 cards
                      key={i}
                      sx={{ display: "flex" }}>
                                  <Card
                                    sx={{
                                      width: "100%",
                                      height: "100%",
                                      display: "flex",
                                      flexDirection: "column",
                                      borderRadius: 2,
                                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                      "&:hover": {
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                        transform: "translateY(-2px)",
                                        transition: "all 0.3s ease",
                                      },
                                    }}
                                  >
                                <CardContent sx={{
                            flexGrow: 1,
                            display: "flex",
                            flexDirection: "column",
                          }}>
                                      {/* Company Name */}
                                      <Skeleton
                                        animation="wave"
                                        variant="text"
                                        width={"100%"} 
                                        height={40}
                                        sx={{ borderRadius: "15px" }}
                                      />
                                      {/* Job Details */}
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: 1,
                                          mb: 2,
                                        }}
                                      >
                                        <Box
                                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                        >
                                          <Skeleton
                                            animation="wave"
                                            variant="text"
                                            width={"100%"}
                                            height={40}
                                            sx={{ borderRadius: "15px" }}
                                          />
                                        </Box>
                                        <Box
                                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                        >
                                          <Skeleton
                                            animation="wave"
                                            variant="text"
                                            width={"100%"}
                                            height={40}
                                            sx={{ borderRadius: "15px" }}
                                          />
                                        </Box>
                                        <Box
                                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                                        >
                                          <Skeleton
                                            animation="wave"
                                            variant="text"
                                            width={"100%"}
                                            height={40}
                                            sx={{ borderRadius: "15px" }}
                                          />
                                        </Box>
                                      </Box>
                
                                      {/* View Jobs Button */}
                                      <Button
                                        variant="outlined"
                                        fullWidth
                                        disabled={!isLoaded}

                                        sx={{
                                          mt: "auto",
                                          textTransform: "none",
                                          borderColor: "#1976d2",
                                          width: "102px",
                                          alignSelf: "flex-end",
                                          color: "#1976d2",
                                          "&:hover": {
                                            borderColor: "#1565c0",
                                            bgcolor: "rgba(25, 118, 210, 0.04)",
                                          },
                                        }}
                                      >
                                        Apply 
                                      </Button>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              ))
              }
            </Grid>

            {/* Pagination */}
            {jobList.length > 0 ? (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <Pagination
                  count={totalPage}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                  sx={{
                    "& .MuiPaginationItem-root": {
                      "&.Mui-selected": {
                        bgcolor: "#006989",
                        "&:hover": {
                          bgcolor: "#005070",
                        },
                      },
                    },
                  }}
                />
              </Box>
            ) : null}
          </Box>
        </Box>
      </Container>

      <Dialog
        TransitionComponent={Transition}
        open={noResultPopUp}
        // onClose={() => setNoResultPopUp(false)}
        sx={{ "& .MuiPaper-root": { color: "white", width: "400px" } }}
      >
        <DialogTitle
          bgcolor="rgb(16 143 178)"
          sx={{ backgroundColor: "rgb(16 143 178)", fontWeight: 600 }}
        >
          Job Search
        </DialogTitle>
        <DialogContent sx={{ mt: 3 }}>
          <DialogContentText sx={{ fontWeight: 600 }}>
            No Jobs for your search
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => {
              setSelectedOptions({
                key_skills: null,
                job_location: null,
                industry: null,
              });

              setNoResultPopUp(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        TransitionComponent={Transition}
        open={jobApplied}
        // onClose={() => setJobApplied(false)}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "rgb(16 143 178)",
            width: "300px",
          },
        }}
      >
        <DialogTitle
          bgcolor="rgb(16 143 178)"
          sx={{ color: "white", fontWeight: 600 }}
        >
          Job Apply
        </DialogTitle>
        <DialogContent sx={{ mt: 1 }}>
          <DialogContentText
            sx={{ color: "white", fontWeight: 600 }}
          ></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => setJobApplied(false)}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        TransitionComponent={Transition}
        open={openMoreDetails2}
        jobDescription2={jobDescription2}
        // onClose={() => setOpenMoreDetails(false)}
        sx={{ "& .MuiPaper-root": { width: "500px" }, zIndex: "99999" }}
      >
        <DialogTitle
          bgcolor="rgb(16 143 178)"
          sx={{ color: "white", fontWeight: 600 }}
        >
          Job Description
        </DialogTitle>
        <DialogContent sx={{ mt: 1 }}>
          {jobDescription2 ? (
            <DialogContentText
              dangerouslySetInnerHTML={{
                __html: jobDescription2,
              }}
            ></DialogContentText>
          ) : (
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                ml: 0.5,
                mt: 2,
              }}
              color="text.secondary"
            >
              No description for this job
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ mr: 2, mb: 1 }}
            variant="outlined"
            onClick={() => setOpenMoreDetails2(false)}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
     <Dialog
        TransitionComponent={Transition}
        open={openMoreDetails}
        jobDescription={jobDescription}
        // onClose={() => setOpenMoreDetails(false)}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "10px",
            maxWidth: "800px",
            height: "80vh",
          },
        }}
      >
        <DialogContent sx={{ padding: "24px" }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              position: "relative",
            }}
          >
            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <img
                src={
                  jobDescription?.logoUpload
                    ? `${baseUrl}employers/logo/email/${jobDescription.employer_email_id}/Admin`
                    : employerdefaultimg
                }
                alt="logo"
                width={64}
                height={64}
                style={{
                  borderRadius: "12px",
                  objectFit: "contain",
                  border: "1px solid #eee",
                  padding: "6px",
                  background: "#fafafa",
                }}
              />

              <Box>
                <Typography
                  sx={{
                    fontFamily: "Poppins-SemiBold",
                    fontSize: "20px",
                    color: "#111",
                  }}
                >
                  {jobDescription?.job_title || "Job Title"}
                </Typography>

                <Typography sx={{ fontSize: "14px", color: "#666" }}>
                  {jobDescription?.company_name || "Company Name"} •{" "}
                  {jobDescription?.job_location || "Location"}
                </Typography>
              </Box>
            </Box>

            {/* Close Button */}
            <IconButton
              aria-label="close"
              onClick={() => setOpenMoreDetails(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: "#000",
              }}
            >
              <Close sx={{ fontSize: "26px" }} />
            </IconButton>
{/* Key Skills */}
{jobDescription?.key_skills && (
  <Box
    sx={{
      mt: 1,
      borderRadius: "12px",
      padding: "14px 16px",
      border: "1px solid #E6EEFF",
    }}
  >
    <Typography
      sx={{
        fontFamily: "Poppins-SemiBold",
        fontSize: "15px",
        mb: 1,
        color: "#111",
      }}
    >
      Key Skills
    </Typography>

    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
      }}
    >
      {(Array.isArray(jobDescription.key_skills)
        ? jobDescription.key_skills
        : jobDescription.key_skills.split(",")
      ).map((skill, index) => (
        <Chip
          key={index}
          label={skill.trim()}
          sx={{
            fontFamily: "Poppins-Medium",
            background: "#E8F0FE",
            color: "#1A4ED8",
            fontSize: "13px",
            height: "28px",
          }}
        />
      ))}
    </Box>
  </Box>
)}
            {/* Meta Info */}
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px",
                mt: 1,
              }}
            >
              <Chip
                label={`Experience: ${jobDescription?.experience_min==""?0:jobDescription?.experience_min} - ${jobDescription?.experience_max===""?1:jobDescription?.experience_max}`}
              />
              <Chip
                label={`Salary: ₹${jobDescription?.salary_range_min} - ₹${jobDescription?.salary_range_max} / ${jobDescription?.salary_type}`}
              />
              <Chip
                label={`Openings: ${jobDescription?.number_of_positions}`}
              />
              <Chip label={jobDescription?.job_status} color="success" />
            </Box>

            {/* Description */}
            <Box
              sx={{
                mt: 2,
                background: "#FAFAFA",
                borderRadius: "12px",
                padding: "16px 18px",
                border: "1px solid #EAEAEA",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins-SemiBold",
                  fontSize: "16px",
                  mb: 1,
                  color: "#111",
                }}
              >
                Job Description
              </Typography>

              {jobDescription?.job_description ? (
                <DialogContentText
                  sx={{
                    fontFamily: "Poppins-Medium",
                    color: "#555",
                    lineHeight: 1.8,

                    "& p": { mb: "10px" },
                    "& strong": { color: "#111" },
                    "& ul": { pl: "20px" },
                    "& li": { mb: "8px" },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize( formatJobDescription(jobDescription.job_description)),
                  }}
                />
              ) : (
                <Typography color="text.secondary">
                  No description for this job
                </Typography>
              )}
            </Box>

            {/* Contact Info */}
            <Box
              sx={{
                mt: 1,
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                fontSize: "14px",
                color: "#666",
              }}
            >
              <Typography>📧 {jobDescription?.contact_email_id}</Typography>
              <Typography>📞 {jobDescription?.phone_number}</Typography>
            </Box>
          </Box>
        </DialogContent>

        {/* <DialogActions>
          <Button
            sx={{ mr: 2, mb: 1 }}
            variant="outlined"
            onClick={() => setOpenMoreDetails(false)}
          >
            Ok
          </Button>
        </DialogActions> */}
      </Dialog>

      <Dialog
        TransitionComponent={Transition}
        open={searchPopUp}
        // onClose={() => setSearchPopUp(false)}
        sx={{ "& .MuiPaper-root": { color: "white", width: "400px" } }}
      >
        <DialogTitle
          bgcolor="rgb(16 143 178)"
          sx={{ backgroundColor: "rgb(16 143 178)", fontWeight: 600 }}
        >
          search
        </DialogTitle>
        <DialogContent sx={{ mt: 5, mb: 2 }}>
          <DialogContentText sx={{ fontWeight: 600 }}>
            Atleast one field is requried for search !
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => setSearchPopUp(false)}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        TransitionComponent={Transition}
        open={login}
        // onClose={() => setLogin(false)}
        sx={{ "& .MuiPaper-root": { color: "white", width: "400px" } }}
      >
        <DialogTitle
          bgcolor="rgb(16 143 178)"
          sx={{ backgroundColor: "rgb(16 143 178)", fontWeight: 600 }}
        >
          Login
        </DialogTitle>
        <DialogContent sx={{ mt: 5, mb: 2 }}>
          <DialogContentText sx={{ fontWeight: 600 }}>
            Please login first to apply job !
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="outlined"
            onClick={() => setLogin(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              navigate("/login");
              setLogin(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
